<template>
  <nav v-if="authed" :class="'spmenu spmenu-vertical spmenu-right '+menuRightCls" id="menu-right">
    <div class="panel list-group">
      <div class="list-group-item meta-box pl-4 pr-4 pt-2">
        <div class="row">
          <img class="user-avatar"/>
          <div class="greeting">Welcome, <b>{{user.username}}</b><br/>
            <!-- <span class="lastLogin">Last login: {{user.last_login}}</span> -->
          </div>
        </div>
        <div class="row user-actions">
          <!--<button class="btn btn-primary btn-sm"></button>-->
          <!--<b-button size="sm" variant="primary">Preferences</b-button>-->
          <b-button @click.prevent="signOut" variant="primary" class="btn-xs">Sign out</b-button>

        </div>
      </div>
      <a v-if="user && user.admin && !boardEnabled" href="#" @click.prevent="navigateToAdminBoard" class="list-group-item">
        <span class="main-nav-menu">Model Management</span>
      </a>
      <a v-if="user && user.admin && boardEnabled" href="#" @click.prevent="navigateToKegsMap" class="list-group-item">
        <span class="main-nav-menu">KEGS Map</span>
      </a>
<!--      <a href="#" v-if="!boardEnabled" @click.prevent="showReleaseModal" class="list-group-item">
        <span class="main-nav-menu">Release Notes</span>
      </a>-->
      <a href="#" @click="toggleSupportShow" class="list-group-item">
        <span class="main-nav-menu">Log Support Ticket</span>
      </a>
      <a href="#" @click="openFieldModeller" v-if="$store.getters['project/currentProject'] && $store.getters['project/currentProject'].workpack && $store.getters['project/currentProject'].workpack.id == 12111" class="list-group-item">
        <span class="main-nav-menu">Field Modeller</span>
      </a>
      <a href="#" @click="openRedmine" target="_blank" class="list-group-item">
        <span class="main-nav-menu">KEGMINE</span>
      </a>
      <a href="#" @click="openWiki" target="_blank" class="list-group-item">
        <icon name="question-circle"></icon>
        <span class="main-nav-menu">Wiki</span>
      </a>
      <!-- <a href="#" v-if="!boardEnabled" class="list-group-item help-btn" @click.prevent="showTourF">
        <icon name="question-circle"></icon>
        <span class="main-nav-menu">Quick help tour</span>
      </a> -->
    </div>
  </nav>
</template>

<script>
  import store from '../store'
  import router from '../router'
  import auth from '../api/auth'
  import IntroJS from 'intro.js'
  import 'vue-awesome/icons/question-circle'

  export default {
    name: 'menu-right',
    computed: {

      releaseNotesShow: {
        get () {
          return this.$store.getters['map/showReleaseNotes']
        },
        set (val) {
          this.$store.commit('map/showReleaseNotes', val)
        },
      },
      showAdmin: {
        get () {
          return this.$store.getters['user/showAdmin']
        },
        set (val) {
          this.$store.commit('user/showAdmin', val)
        }
      },
      showTour: {
        get () {
          return this.$store.getters['map/showTour']
        },
        set (val) {
          this.$store.commit('map/showTour', val)
        },
      },
      projects: () => this.$store.getters['project/projects'],
      menuRightCls: {
        get() {
          return this.$store.getters['user/menuRightCls']
        },
        set(val) {
          this.$store.commit('user/menuRightCls', val)
        }
      },
      authed () {
        return this.$store.getters['user/authed'] && this.$store.getters['user/verified']
      },
      user () {
        return this.$store.getters['user/user']
      },
      boardEnabled () {
        return this.$store.getters['project/dashboardEnabled'] || this.$store.getters['project/projectboardEnabled']
      },
      supportShow: {
        get () {
          return this.$store.getters['cmp/all']['support']['enabled']
        },
        set (val) {
          this.$store.getters['cmp/all']['support']['enabled'] = val
        },
      },
      wikiProjectId () {
        return this.$store.getters['project/wikiProjectId']
      },
    },
    methods: {
      navigateToAdminBoard () {
        this.menuRightCls = ''
        this.$store.commit('project/projectboardEnabled', true)
        this.$router.push({name: 'project-management', params: { workpack_id: this.$store.getters['project/currentProject'].workpack.id}})
      },
      navigateToKegsMap () {
        this.menuRightCls = ''
        this.$store.commit('project/projectboardEnabled', false)
        // workaround map not loading correctly use name map route
        location.href = `/${this.$store.getters['project/currentProject'].workpack.id}`

      },
      toggleSupportShow () {
        this.supportShow = !this.supportShow
        this.menuRightCls = ''
      },
      signOut () {
        auth.signOut()
      },
      openRedmine () {
        let win = window.open('/mine/projects')
        win.focus()
        this.menuRightCls = ''
      },
      openWiki () {
        let win = window.open('/mine/projects/' + this.wikiProjectId + '/wiki')
        win.focus()
      },
      openFieldModeller () {
        let win = window.open('https://nb.kegsys.com/')
        win.focus()
      },
      showReleaseModal () {
        this.releaseNotesShow = !this.releaseNotesShow
        this.menuRightCls = ''
      },
      showTourF () {
        this.menuRightCls = ''
        if (this.$route.name === 'map') {
          this.startIntro()
          return
        }
        let project = this.projects.filter(p => p.workpack)[0]
        if (project) {
          router.push('/${project.workpack.id}')
          setTimeout(() => {
            this.startIntro()
          }, 1000)
        } else {
          this.$notify({
            title: 'ERROR',
            text: 'In order to view the help tour you need to have access to at least one workpack',
            type: 'error'
          })
        }
      },
      startIntro () {
        let intro = IntroJS.introJs()
        intro.setOption("showStepNumbers", false)
        intro.start()
        intro.onafterchange((el) => {
          if (el.dataset.showui === 'search') {
            setTimeout(() => {
              intro.refresh()
            }, 500)
          }
        })
      }
    },
    watch: {
      showTour (val) {
        if (val) {
          this.showTourF()
          this.showTour = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MenuRight.vue